
(function () {
    angular.module('tmx-app').factory('RoleManagementService', ['$q','$mdMedia', 'tmxResource', 'cacheStore', function ($q,$mdMedia, tmxResource, cacheStore) {

        var roles = tmxResource("Role");
        roles.status = [
            {
                HiddenValue: "active",
                VisibleValue: "Active"
            },
            {
                HiddenValue: "inactive",
                VisibleValue: "Inactive"
            },
            {
                HiddenValue: "pending",
                VisibleValue: "Pending"
            }
        ];

        roles.gridColumn = [
            {
                field: "RoleName",
                title: "RoleName",
                type: "string",                
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : RoleManagementCtrl.isFiltered('RoleName')}\" >{{'RoleName' | translate}} <i class='fa fa-filter' ng-if='RoleManagementCtrl.isFiltered(\"RoleName\")' ></i></span>"


            },
            //{
            //    field: "tenantName",
            //    title: "Tenant Name",
            //    type:"string",
            //    headerTemplate:"<span  ng-class=\"{ 'filter-active' : RoleManagementCtrl.isFiltered('tenantName')}\" >Tenant Name <i class='fa fa-filter' ng-if='RoleManagementCtrl.isFiltered(\"tenantName\")' ></i></span>"
            //
            //
            //},
            {
                field: "RoleDescription",
                title: "RoleDescription",
                type: "string",                
                hidden:true,
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : RoleManagementCtrl.isFiltered('RoleDescription')}\" >{{'RoleDescription' | translate}} <i class='fa fa-filter' ng-if='RoleManagementCtrl.isFiltered(\"RoleDescription\")' ></i></span>"

            },
            {
                field: "UserCount",
                title: "AssignedUsers",
                type: "string",                
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : RoleManagementCtrl.isFiltered('UserCount')}\" >{{'AssignedUsers' | translate}} <i class='fa fa-filter' ng-if='RoleManagementCtrl.isFiltered(\"UserCount\")' ></i></span>"

            },
            {
                field: "Status",
                title: "Status",
                type: "select",
                data: roles.status,                
                hidden:true,
                headerTemplate: "<span  ng-class=\"{ 'filter-active' : RoleManagementCtrl.isFiltered('Status')}\" >{{'Status' | translate}} <i class='fa fa-filter' ng-if='RoleManagementCtrl.isFiltered(\"Status\")' ></i></span>"

            },
            {
                field: "",
                width: $mdMedia('gt-sm')?'6%':'150px',
            }

        ];
        roles.filterColumns = [
            {
                field: "RoleName",
                title: "RoleName",
                type: "string",
                search: true
            },
            {
                field: "Status",
                title: "Status",
                type: "select",
                data: roles.status
                //headerTemplate:"<span  ng-class=\"{ 'filter-active' : RoleManagementCtrl.isFiltered('Status')}\" >Status <i class='fa fa-filter' ng-if='RoleManagementCtrl.isFiltered(\"Status\")' ></i></span>"

            }
            //{
            //    field: "UserCount",
            //    title: "Assigned Users",
            //    type:"string",
            //    //headerTemplate:"<span  ng-class=\"{ 'filter-active' : RoleManagementCtrl.isFiltered('RoleDescription')}\" >Assigned Users <i class='fa fa-filter' ng-if='RoleManagementCtrl.isFiltered(\"RoleDescription\")' ></i></span>"
            //
            //}
        ];
        roles.columns = angular.copy(roles.gridColumn);
        ///////////////************************FUNCTIONS**********************************************8/////////////////////\
        roles.getEntity = function () {

            return tmxResource("").getByAction("entity", false);
        };
        ///////////////////////////////GET ALL ROLES: LIST RESOLVE////////////////////////////////////////////////////////
        roles.getAllRoles = function () {
            return tmxResource("Role").all();
        };
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        roles.getAllPrivileges = function () {
            return tmxResource("Privileges/list").all();
        };
        /////////////USED IN leftbar directive to set app visibility and privileges to the logged in user///////////////////
        roles.getLoggedInUserPrivileges = function () {
            var deferred = $q.defer();
               
            var savedPrivileges = cacheStore.get("LoggedInUserPrivileges"); //localStorage.getItem('LoggedInUserPrivileges');
            if(savedPrivileges){
                deferred.resolve(savedPrivileges);
                return deferred.promise;
            }
            tmxResource("Privileges").getByAction("entities", false).then(function (response) {
                if (response) {
                    cacheStore.set("LoggedInUserPrivileges", JSON.stringify(beautifyPrivileges(response.data)));
                    localStorage.setItem('LoggedInUserPrivileges', JSON.stringify(beautifyPrivileges(response.data)));
                    try{
                        firebase.setTmxUserProperties({UserRole: response.data[0].RoleName})
                    }
                    catch(e){
                        console.log('Unable to set user role property');
                    }
                    deferred.resolve(response.data);
                }
                else {
                    deferred.reject("Unable to load privileges");
                }
            });
            return deferred.promise;
        };

        //#region //////======== Private Functions======================
        function Role(_id, _name) {
            var vm = this;
            vm.id = _id;
            vm.name = _name;
        }

        function Privilege(_id, _name) {
            var vm = this;
            vm.id = _id;
            vm.name = _name;
        }

        function Entity(_id, _name) {
            var vm = this;
            vm.id = _id;
            vm.name = _name;
            vm.privileges = {};
        }

        function ViewEntity(_key, _value) {
            var vm = this;
            vm.key = _key;
            vm.value = _value;
        }

        function beautifyPrivileges(data) {
            var bData = {
                roles: {},
                entities: {},
                viewEntities: {}
            };
            for (var i in data) {
                if (data.hasOwnProperty(i)) {
                    bData.roles[data[i].RoleId] = new Role(data[i].RoleId, data[i].RoleName);
                    for (var j = 0; j < data[i].Entity.length; j++) {
                        var entity = data[i].Entity[j];
                        bData.entities[entity.EntityName] = new Entity(entity.EntityId, entity.EntityName);
                        for (var k = 0; k < entity.Privileges.length; k++) {
                            var privilege = entity.Privileges[k];
                            bData.entities[entity.EntityName].privileges[privilege.PrivilegeName] = new Privilege(privilege.PrivilegesId, privilege.PrivilegeName);
                        }
                    }
                    for (j = 0; j < data[i].ViewEntities.length; j++) {
                        var viewEntity = data[i].ViewEntities[j];
                        bData.viewEntities[viewEntity.Key] = new ViewEntity(viewEntity.Key, viewEntity.Value);
                    }
                }
            }
            return bData;
        }
        //#endregion

        /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        return roles;

    }]);
})();